import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';

import { ModalBottomsheetHelper, ModalBottomsheetType } from '../modal-bottomsheet/modal-bottomsheet.helper';

@Component({
  selector: 'planone-confirm-button',
  templateUrl: './confirm-button.component.html',
  styleUrl: './confirm-button.component.scss',
})
export class ConfirmButtonComponent {
  @ViewChild('confirmTitle') confirmTitle: TemplateRef<never> | null | undefined;
  @ViewChild('confirmText') confirmText: TemplateRef<never> | null | undefined;

  @Input() size: string | undefined | null;
  @Input() outlet: 'button' | 'link' = 'button';
  @Input() disabled = false;
  @Input() color: 'primary' | 'secondary' | 'accent' = 'primary';
  @Input() icon: string | undefined | null;
  @Input() text = '';
  @ContentChild('text') textTemplate: TemplateRef<never> | null | undefined;

  @Input() dialogTitle = $localize`:@@confirmButton-confirmFalse:Zustimmung erforderlich`;
  @Input() dialogText = '';
  @ContentChild('dialogTitle') dialogTitleTemplate: TemplateRef<never> | null | undefined;
  @ContentChild('dialogText') dialogTextTemplate: TemplateRef<never> | null | undefined;

  @Input() confirmTrue = $localize`:@@confirmButton-confirmTrue:Zustimmen`;
  @Input() confirmFalse = $localize`:@@confirmButton-confirmCancel:Abbrechen`;

  @Output() confirm = new EventEmitter<void>();
  @Output() decline = new EventEmitter<void>();

  constructor(private modalBottomSheetHelper: ModalBottomsheetHelper) {}

  openDialog(): void {
    this.modalBottomSheetHelper.openDialog(
      ModalBottomsheetType.general,
      this.confirmTitle,
      this.confirmText,
      'desktop',
      {},
      undefined,
      {
        width: this.size === 'phone' ? 'calc(100% - 4rem)' : '600px',
        panelClass: 'confirm-dialog-modal',
      }
    );
  }

  onConfirm(): void {
    this.modalBottomSheetHelper.closeDialog();
    this.confirm.emit();
  }

  onDecline(): void {
    this.modalBottomSheetHelper.closeDialog();
    this.decline.emit();
  }
}
